import axios from "axios";
import { SET_SPINNER_LOADING } from "@/store/modules/common/constants";
import {
  EVENT_UPDATED_USER_TIME_ZONE,
  EVENT_ERROR_TOAST_MESSAGE
} from "@/store/events";
import { EventBus } from "@/event-bus";
import commonStore from "@/store/modules/common";
/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parseJSON(response) {
  return response.data;
}

/**
 * Return the response object.
 *
 * @param {object} response
 * @return {object}
 */
function parseResponse(response) {
  return response;
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response) {
  if (response && response.status >= 200 && response.status < 300) {
    return response;
  }
  // const error = new Error(response.statusText);
  // error.response = response;
  // throw error;
  throw response;
}

/**
 * Add set timeout for api call,
 * if time is exceeded then throwing error timeout
 * regardless request is still calling in background
 *
 * @param  {promise function} fetchPromise Promise function
 * @param  {integer} ms                    Timeout in ms
 * @return {promise}                       The response
 */
// function promiseNoAction (fetchPromise) {
//   return new Promise((resolve, reject) => {
//     fetchPromise
//       .then(
//         (res) => {
//           const response = res;
//           response.doubleClick = true;
//           resolve(response);
//         },
//         (err) => {
//           reject(err);
//         }
//       );
//   });
// }

function fetchWithTimeout(fetchPromise, ms, dispatch) {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => reject(new Error("Time out")), ms);
    fetchPromise.then(
      res => {
        dispatch && dispatch(SET_SPINNER_LOADING, false);
        clearTimeout(timeoutId);
        resolve(res);
      },
      err => {
        dispatch && dispatch(SET_SPINNER_LOADING, false);
        clearTimeout(timeoutId);
        reject(err);
      }
    );
  });
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export function makeCall(url, options, dispatch) {
  // TODO: check state is Loading, call api with no action
  // if (commonStore.state.isLoading) {
  //   return promiseNoAction(axios(url, options));
  // }
  if (!commonStore.state.isLoading) {
    dispatch && dispatch(SET_SPINNER_LOADING, true);
    EventBus.$emit(EVENT_UPDATED_USER_TIME_ZONE);
  }
  return fetchWithTimeout(axios(url, options), 30000, dispatch)
    .then(checkStatus)
    .then(parseJSON);
}

/**
 * Request a download URL.
 *
 * @param {string} url Request url.
 * @param {object} options
 * @param {object} dispatch
 * @returns {object}
 */
export function makeDownload(url, options, dispatch) {
  if (!commonStore.state.isLoading) {
    dispatch(SET_SPINNER_LOADING, true);
    EventBus.$emit(EVENT_UPDATED_USER_TIME_ZONE);
  }
  return fetchWithTimeout(axios(url, options), 30000, dispatch)
    .then(checkStatus)
    .then(parseResponse);
}

export function handleProgramServiceError(error) {
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.error &&
    error.response.data.error.message
  ) {
    if (
      error.response.data.error.message.title &&
      error.response.data.error.message.title !== ""
    ) {
      EventBus.$emit(
        EVENT_ERROR_TOAST_MESSAGE,
        error.response.data.error.message.title
      );
    } else if (
      error.response.data.error.message.message &&
      error.response.data.error.message.message !== ""
    ) {
      EventBus.$emit(
        EVENT_ERROR_TOAST_MESSAGE,
        error.response.data.error.message.message
      );
    }
  }
}

export function handleErrorMessage(error) {
  if (error.message) {
    if (typeof (error.message) === 'object') {
      let messages = [];
      for (const key in error.message) {
        if (error.message.hasOwnProperty(key)) {
          let message = error.message[key];
          if (typeof(message) === 'object') {
            // Message array
            messages = messages.concat(message);
          } else {
            messages.push(message);
          }
        }
      }
      EventBus.$emit(EVENT_ERROR_TOAST_MESSAGE, messages.join('<br><br>'));
    } else {
      EventBus.$emit(EVENT_ERROR_TOAST_MESSAGE, error.message);
    }
  } else {
    EventBus.$emit(EVENT_ERROR_TOAST_MESSAGE, 'Something went wrong');
  }
}



// WEBPACK FOOTER //
// ./src/utils/request.js